import {
  GET_HEALTH_PLANS_REQUEST,
  GET_HEALTH_PLANS_SUCCESS,
  GET_HEALTH_PLANS_ERROR,
} from "../actions/type";

const fetchHealthPlans =
  (formData = {}, headers = {}) =>
  async (dispatch, getState, api) => {
    dispatch(fetchHealthPlansRequest());

    return api.fetchHealthPlans(formData,headers).then(data => {
        dispatch(fetchHealthPlansSuccess(data));
    }).catch(err => {
        dispatch(fetchHealthPlansError(err));
    })
  };

export default fetchHealthPlans;

const fetchHealthPlansRequest = () => ({ type: GET_HEALTH_PLANS_REQUEST });

const fetchHealthPlansSuccess = (response) => ({
    type: GET_HEALTH_PLANS_SUCCESS,
    data: response,
    lastUpdated: Date.now(),
});

const fetchHealthPlansError = (error) => ({
  type: GET_HEALTH_PLANS_ERROR,
  error,
  lastUpdated: Date.now(),
});
